import React from "react";
import { useTranslation } from "react-i18next";
const PrivacyPolicy = () => {
    const { t } = useTranslation();
    const subPrivacyPolicy = [
        {
            title: t("Privacy_Policy.sub_privacy_policy.title1"),
            content: t("Privacy_Policy.sub_privacy_policy.content1")
        },
        {
            title: t("Privacy_Policy.sub_privacy_policy.title2"),
            content: t("Privacy_Policy.sub_privacy_policy.content2")
        },
        {
            title: t("Privacy_Policy.sub_privacy_policy.title3"),
            content: t("Privacy_Policy.sub_privacy_policy.content3")
        },
        {
            title: t("Privacy_Policy.sub_privacy_policy.title4"),
            content: t("Privacy_Policy.sub_privacy_policy.content4")
        },
        {
            title: t("Privacy_Policy.sub_privacy_policy.title5"),
            content: t("Privacy_Policy.sub_privacy_policy.content5")
        },
    ]
    const privacyPolicy = [
        {
            title: t("privacy_policy"),
            content: (
                <>
                    <p className="exado-subTitle-two">
                        {t("Privacy_Policy.privacy_policy.line1")}
                        <br />
                        <br />
                        {t("Privacy_Policy.privacy_policy.line2")}
                        <br />
                        <br />
                        {t("Privacy_Policy.privacy_policy.line3")}
                        <br />
                        <br />
                        {t("Privacy_Policy.privacy_policy.line4")}
                        <br />
                        <br />
                        {t("Privacy_Policy.privacy_policy.line5")}
                    </p>
                </>
            ),
        },
        {
            title: t("Privacy_Policy.what_data_we_collect"),
            content: (
                <>
                    {subPrivacyPolicy.map((item, index) => (
                        <article key={index}>
                            <h3 className="exado-title-three subPrivacyPolicy-head">
                                {item.title}
                            </h3>
                            <p className="exado-subTitle-two">
                                {item.content}
                            </p>
                        </article>
                    )

                    )

                    }
                </>


            ),
        },
    ];

    return (
        <div className="privacy-policy-page">
            <section className="privacy-policy-section">
                {privacyPolicy.map((item, index) => (
                    <article key={index}>
                        <div>
                            <h1 className="exado-subTitle-one">{index + 1}. {item.title}</h1>
                            {item.content}
                        </div>
                    </article>
                ))}
            </section>
        </div>
    );
};

export default PrivacyPolicy;
